module.exports = __webpack_public_path__ + "img/cover-icon-square.d6149339.svg";